import { Component, createRef } from 'react'
import { withRouter } from 'react-router-dom'
import clx from 'classnames'
import _ from 'lodash'
import { Anchor } from 'antd'
import { Icon } from '@vzmi/shp_shared_compo'
import styles from './Anchor.css'

const { Link: AnchorLink } = Anchor

class CommonAnchor extends Component {
  constructor (props) {
    super(props)
    this.state = {
      current: _.get(_.head(this.props.items), 'link'),
      isSubMenuHovered: false,
      isSubMenuFocused: false,
      isSubMenuItemActived: false,
      lastScrollX: 0
    }
    this.container = createRef()
    this.debounceHandleScroll = _.debounce(this.updateAnchorPosition, 50)
  }

  componentDidMount () {
    const { location } = this.props
    // 第一次進入時如果瀏覽器已經 X 軸不是 0 需要重新調整
    this.updateAnchorPosition()
    window.addEventListener('scroll', this.debounceHandleScroll, true)
    window.addEventListener('resize', this.debounceHandleScroll, true)
    this.setIsSubMenuItemActived(location.hash)
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.debounceHandleScroll)
    window.removeEventListener('resize', this.debounceHandleScroll)
  }

  // 需要 retry 是因為 affix 只有在 anchor 是 fixed 的狀態才會出現
  // 如果是第一次進入頁面 affix 不會立刻出現
  getAnchorAffix = (retry = 3) => {
    const container = this.container.current
    const anchorAffix = container && container.querySelector('.ant-affix')
    if (anchorAffix) {
      return Promise.resolve(anchorAffix)
    }
    if (retry > 0) {
      const retryGetAnchorAffix = new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getAnchorAffix(retry - 1))
        }, 10)
      })
      return retryGetAnchorAffix
    }
    return Promise.resolve()
  }

  // 因為 antd anchor 是 fixed 且不會計算 X 軸滾動，需要自己動態修改 X 軸相對位置
  updateAnchorPosition = async () => {
    const { targetContainer } = this.props
    const { x: anchorXPosition } = targetContainer
      ? targetContainer.getBoundingClientRect()
      : {}
    const anchorAffix = await this.getAnchorAffix()
    if (anchorAffix && !_.isUndefined(anchorXPosition)) {
      window.requestAnimationFrame(() => {
        anchorAffix.style.left = `${anchorXPosition}px`
      })
    }
  }

  handleAnchorChange = link => {
    const { withHashLink = true } = this.props
    if (!_.isEmpty(link)) {
      this.setIsSubMenuItemActived(link)
      this.setState({ current: _.replace(link, '#', '') })
      // 不在 anchor 變更時更新 hash link
      if (!withHashLink) {
        return
      }

      // 只替換 hash link
      window.history.replaceState(undefined, undefined, link)
    }
  }

  updateSubMenuFocused = isOpened => this.setState({
    isSubMenuFocused: isOpened
  })

  updateSubMenuDropdownFocused = isOpened => this.setState({
    isSubMenuDropdownFocused: isOpened
  })

  handleSubMenuClick = () => this.updateSubMenuFocused(!this.state.isSubMenuFocused)

  handleSubMenuHover = isHovered => () => this.setState({ isSubMenuHovered: isHovered })

  handleSubMenuBlur = () => {
    setTimeout(() => this.updateSubMenuFocused(false), 700)
  }

  setIsSubMenuItemActived = (hash) => {
    const { subItems } = this.props
    const isSubMenuItemActived = _.some(subItems, ({ link }) => `#${link}` === hash)
    this.setState({ isSubMenuItemActived })
  }

  render () {
    const {
      items,
      subItems,
      onClick = () => {},
      withDashboardMode = true,
      withCenterItemsModel
    } = this.props
    const {
      isSubMenuFocused,
      isSubMenuHovered,
      isSubMenuItemActived
    } = this.state
    const firstItemLink = _.get(_.head(items), 'link')
    const isSubMenuEmpty = _.isEmpty(subItems)
    const isSubMenuActived = (isSubMenuHovered || isSubMenuFocused)

    return (
      <div
        ref={this.container}
        className={styles.anchorContainer}
      >
        <Anchor
          className={clx(
            styles.Anchor,
            { [styles.center]: withCenterItemsModel },
            { [styles.selectedStartItem]: this.state.current === firstItemLink },
            // withDashboardMode 會讓 anchor 最後一項至右
            { [styles.mainMenuOnly]: isSubMenuEmpty && withDashboardMode }
          )}
          onChange={this.handleAnchorChange}
          onClick={onClick}
          targetOffset={75}
        >
          {items.map(({ link, linkTitle }) => {
            return (
              <AnchorLink
                key={link}
                href={`#${link}`}
                title={linkTitle}
              />
            )
          })}
          {
            !isSubMenuEmpty && (
              <div
                className={clx(
                  styles.subMenuArea,
                  { [styles.active]: isSubMenuFocused || isSubMenuItemActived },
                  { [styles.hover]: isSubMenuHovered }
                )}
                onClick={this.handleSubMenuClick}
                onBlur={this.handleSubMenuBlur}
                onMouseEnter={this.handleSubMenuHover(true)}
                onMouseLeave={this.handleSubMenuHover(false)}
                tabIndex={-1}
              >
                <span className={styles.subMenuBtn}>
                  看更多
                  {' '}
                  <Icon
                    name='caret-down'
                    color={isSubMenuActived ? '#26282a' : '#979ba7'}
                    align='middle'
                  />
                </span>
                <ul
                  className={clx(
                    styles.linksDropDown,
                    { [styles.hidden]: !isSubMenuFocused }
                  )}
                >
                  {subItems.map(({ link, linkTitle }) => {
                    return (
                      <li key={link}>
                        <AnchorLink
                          href={`#${link}`}
                          className={styles.subLink}
                          title={linkTitle}
                        />
                      </li>
                    )
                  })}
                </ul>
              </div>
            )
          }
        </Anchor>
      </div>
    )
  }
}

export default withRouter(CommonAnchor)
